import { Avatar, Typography } from "@mui/material";
import { useOtp } from "context/OtpContext";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import SimpleBackdrop from "components/MDLoader_Backdrop";
import MailOutlineIcon from "@mui/icons-material/MailOutline"; // MUI icon
import { useState } from "react";
import PasswordSignIn from "./PasswordSignIn";
import PhoneIcon from "@mui/icons-material/Phone";
import { OTP_LENGTH } from "constants/authConstants";
import IdentifierInput from "./OtpSignInModal/IdentifierInput";
import OtpInputForm from "./OtpSignInModal/OtpInputForm";
import KnowMeForm from "./AuthModal/KnowMeForm";
import PropTypes from "prop-types";

const isPhoneNumber = (value) => {
  const digitsOnly = value.replace(/\D/g, "");
  return /^(\+?[0-9]{10,15})$/.test(digitsOnly);
};

const LoginProcessAuth = ({ gtmCode, campaignCode, referrerCode, storeId, brandId, campaignDetails }) => {
  const { isOtpSent, isLoading, message, identifier } = useOtp();
  const [level, setLevel] = useState(0);
  const [authSection, setAuthSection] = useState("code");

  return (
    <>
      {authSection === "code" && (
        <>
          {level === 0 ? (
            <>
              <Card sx={{ margin: 2, marginLeft: 3, maxWidth: "548px" }}>
                <MDBox mx={2} p={2} textAlign="center" minWidth={{ xs: "320px", xl: "380px" }}>
                  {/*Show Email/Phone Icon On OTP Sent */}
                  {isOtpSent && (
                    <MDBox
                      mb={"24px"}
                      mt={"12px"}
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Avatar
                        sx={{
                          bgcolor: "#CEFFE1",
                          width: 48,
                          height: 48,
                        }}
                      >
                        {isPhoneNumber(identifier) ? (
                          <PhoneIcon sx={{ fontSize: 24, color: "rgb(16, 121, 72)" }} />
                        ) : (
                          <MailOutlineIcon sx={{ fontSize: 24, color: "rgb(16, 121, 72)" }} />
                        )}
                      </Avatar>
                    </MDBox>
                  )}

                  <MDTypography
                    sx={{ color: "#101828", fontSize: "28px" }}
                    variant="h4"
                    fontWeight="medium"
                    mt={1}
                    mb={"20px"}
                  >
                    {isOtpSent &&
                      `Please check your ${isPhoneNumber(identifier) ? "SMS" : "email"} `}
                  </MDTypography>
                </MDBox>

                <MDBox pb={"24px"} px={"24px"}>
                  {!isOtpSent ? (
                    <IdentifierInput
                      label="Email Address or Phone Number"
                      isSignup={false}
                      gtmCode={gtmCode}
                      setAuthSection={setAuthSection}
                      campaignCode={campaignCode}
                      campaignDetails={campaignDetails}
                      storeId={storeId}
                      brandId={brandId}
                    />
                  ) : (
                    <OtpInputForm
                      gtmCode={gtmCode}
                      setLevel={setLevel}
                      length={OTP_LENGTH}
                      campaignCode={campaignCode}
                      campaignDetails={campaignDetails}
                      storeId={storeId}
                      brandId={brandId}
                    />
                  )}
                </MDBox>
              </Card>
            </>
          ) : (
            <Card sx={{ margin: 2, marginLeft: 3, maxWidth: "408px" }}>
              <MDBox mx={2} p={2} textAlign="center" minWidth={{ xs: "320px", xl: "380px" }}>
                <MDTypography
                  sx={{ color: "#101828", fontSize: "28px" }}
                  variant="h4"
                  fontWeight="medium"
                  mt={1}
                  mb={"20px"}
                >
                  Let us get to know you
                </MDTypography>
              </MDBox>

              <MDBox pb={"24px"} px={"24px"}>
                <KnowMeForm
                  setLevel={setLevel}
                  storeId={storeId}
                  brandId={brandId}
                  campaignCode={campaignCode}
                  referrerCode={referrerCode}
                  gtmCode={gtmCode}
                  campaignDetails={campaignDetails}
                />
              </MDBox>

              <Typography
                mx={2}
                px={2}
                pb={2}
                variant="body2"
                textAlign={"center"}
                style={{
                  maxWidth: "360px",
                  fontSize: "0.8rem",
                  color: message && message.type === "error" ? "#f44336" : "#238856",
                  fontWeight: 500,
                }}
              >
                {message?.type === "error" && message?.message}
              </Typography>
            </Card>
          )}
          {isLoading && <SimpleBackdrop />}
        </>
      )}

      {/* PASSWORD SIGN IN FOR EXISTING USERS  */}
      {authSection === "password" && (
        <PasswordSignIn gtmCode={gtmCode} setAuthSection={setAuthSection} />
      )}
    </>
  );
};

export default LoginProcessAuth;

LoginProcessAuth.propTypes = {
  gtmCode: PropTypes.string,
  campaignCode: PropTypes.string,
  referrerCode: PropTypes.string,
  storeId: PropTypes.string,
  brandId: PropTypes.string,
  campaignDetails: PropTypes.object,
};
